"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
var _styles = require("./styles");
const Spacing = _react.default.memo(({
  type = 'margin',
  all,
  top,
  bottom,
  left,
  right,
  vertical,
  horizontal,
  className,
  children = null,
  ...rest
}) => _react.default.createElement(_styles.SpacingBox, (0, _extends2.default)({
  $type: type,
  all: all,
  top: top,
  bottom: bottom,
  left: left,
  right: right,
  vertical: vertical,
  horizontal: horizontal,
  className: className
}, rest), children));
const SpacingShape = _propTypes.default.shape({
  general: _propTypes.default.oneOf(_constants.sizes).isRequired,
  tablet: _propTypes.default.oneOf(_constants.sizes),
  desktop: _propTypes.default.oneOf(_constants.sizes)
});
Spacing.propTypes = {
  type: _propTypes.default.oneOf(['padding', 'margin']),
  all: SpacingShape,
  top: SpacingShape,
  bottom: SpacingShape,
  left: SpacingShape,
  right: SpacingShape,
  vertical: SpacingShape,
  horizontal: SpacingShape,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = exports.default = Spacing;